import { Container, SimpleGrid, Title } from '@mantine/core';
import DataPanelCifrasRDI from '../CustomComponents/DatePanelCifrasRDI';



const CifrasRDI = () => {
  return (
    <>
      <Container
        fluid
        p="md"
        style={{
          flex: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          marginRight: '20px'
        }}
      >
        <Title order={1} style={{ marginBottom: 20 }}>Ejecución Cifras de control</Title>
        <SimpleGrid cols={{ base: 1, xs: 4 }} style={{ flex: 1 }} spacing="md">
          <DataPanelCifrasRDI />
        </SimpleGrid>
      </Container>


    </>

  );

}

export default CifrasRDI;